import { apiFetch, type AjaxResult } from './http';

export type AffiliateOverview = {
  referralCode: string;
  referralLink: string;
  totalInvited: number;
  activeUsers: number;
  totalEarned: number;
  pendingEarned: number;
  commissionRate: string;
};

export type CommissionRecord = {
  commissionId: number;
  invitedUserId: number | null;
  amount: number;
  status: string;
  createTime: string;
};

export async function fetchAffiliateOverview(): Promise<AjaxResult<AffiliateOverview>> {
  return apiFetch('/api/app/affiliate/overview', { method: 'GET', auth: true });
}

export async function fetchAffiliateCommissions(): Promise<AjaxResult<CommissionRecord[]>> {
  return apiFetch('/api/app/affiliate/commissions', { method: 'GET', auth: true });
}
